'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var actionTypes = {
    PENDING: '@@redux-pender/PENDING',
    SUCCESS: '@@redux-pender/SUCCESS',
    FAILURE: '@@redux-pender/FAILURE',
    CANCEL: '@@redux-pender/CANCEL',
    RESET: '@@redux-pender/RESET'
};

exports.default = actionTypes;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-pender/lib/actionTypes.js
// module id = 165
// module chunks = 0